<template>
  <div id="app">
    <v-fab-transition>
      <v-btn
        color="primary"
        fab
        large
        dark
        class="v-btn--open-dialog"
        @click="parametersDialog = !parametersDialog"
        style="z-index: 100"
      >
        <v-icon v-if="!parametersDialog">keyboard_arrow_right</v-icon>
        <v-icon v-if="parametersDialog">keyboard_arrow_left</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="parametersDialog" max-width="600px">
      <v-card class="mx-auto" max-width="1000">
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-domain"
                  v-model="companies"
                  :items="uniqueCompanies"
                  label="Companies"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="isAdminRole">
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-account-multiple"
                  v-model="participants"
                  :items="uniqueParticipants"
                  label="Participants"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-menu
                  v-model="from"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fromDate"
                      label="From"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    @input="from = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  v-model="to"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="toDate"
                      label="To"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    @input="to = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-btn
                @click="parametersDialog = !parametersDialog"
                color="red"
                dark
                >Close</v-btn
              >
              <div class="flex-grow-1"></div>
              <v-btn @click="drawCharts()" color="info">Update</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container style="width: 100%; max-width: 960px">
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <p class="text-center display-1 primary--text">Core company feedback</p>

      <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text">Support</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="supportLoaded"
                      :chartdata="dataCollectionSupport"
                      :options="chartOptionsSupport"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Communication</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="communicationLoaded"
                      :chartdata="dataCollectionCommunication"
                      :options="chartOptionsCommunication"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text">Impact</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="impactLoaded"
                      :chartdata="dataCollectionImpact"
                      :options="chartOptionsImpact"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="4" class="flex-grow-1 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Performance</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="performanceLoaded"
                      :chartdata="dataCollectionPerformance"
                      :options="chartOptionsPerformance"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="4" class="flex-grow-1 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text">Value</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="valueformoneyLoaded"
                      :chartdata="dataCollectionValueformoney"
                      :options="chartOptionsValueformoney"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="12" class="flex-grow-0 ma-2">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Participants</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>

              <v-card-text>
                <!-- <v-row>
                <v-col cols="12">-->
                <bar-chart
                  v-if="participantsLoaded"
                  :chartdata="dataCollection"
                  :options="chartOptions"
                  :height="300"
                  :width="900"
                ></bar-chart>
                <!-- </v-col>
                </v-row>-->
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="12" class="flex-grow-0 ma-2">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Tabular data</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>

              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="graphDataTable"
                :search="search"
              >
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import CompanySurvey from "../classes/CompanySurvey2022";
import BarChart from "@/components/chartjs/BarChart";
import PieChart from "@/components/chartjs/PieChart";
import moment from "moment";

export default {
  components: {
    BarChart,
    PieChart,
  },
  async created() {
    const companySurvey = new CompanySurvey(null);
    await companySurvey.getGraphData();
    this.uniqueCompanies = await companySurvey.getUniqueCompanyNames();
    this.uniqueCompanies.unshift("All");
    this.uniqueParticipants = await companySurvey.getUniqueParticipants();
    this.uniqueParticipants.unshift("All");
    this.drawCharts();
  },
  data: () => ({
    uniqueCompanies: [],
    uniqueParticipants: [],
    from: false,
    fromDate: null,
    to: false,
    toDate: null,
    participants: "All",
    service: "All",
    participantsLoaded: false,
    companies: "All",
    graphData: {},
    graphDataTable: [],
    dataCollection: {},
    chartOptions: {
      responsive: false,
      maintainAspectRatio: false,
    },
    dataCollectionSupport: {},
    chartOptionsSupport: {},
    supportLoaded: false,

    dataCollectionPerformance: {},
    chartOptionsPerformance: {},
    performanceLoaded: false,

    dataCollectionImpact: {},
    chartOptionsImpact: {},
    impactLoaded: false,

    dataCollectionCommunication: {},
    chartOptionsCommunication: {},
    communicationLoaded: false,

    dataCollectionValueformoney: {},
    chartOptionsValueformoney: {},
    valueformoneyLoaded: false,

    dataCollectionRecommend: {},
    chartOptionsRecommend: {},
    roles: [],
    search: "",
    headers: [
      {
        text: "Company",
        align: "start",
        value: "companyName",
      },
      {
        text: "Participant",
        value: "participant",
      },
      { text: "Feedback", value: "feedback" },
    ],
    email: null,
    parametersDialog: false,
    loading: false,
  }),
  methods: {
    async drawCharts() {
      this.parametersDialog = false;
      this.loading = true;
      let filter = null;
      let query = [];

      if (this.companies && this.companies !== "All") {
        query.push({ companyName: { contains: this.companies } });
      }

      if (this.participants && this.participants !== "All") {
        query.push({ participants: { contains: this.participants } });
      }

      if (this.fromDate && this.toDate) {
        const from = moment(this.fromDate).toISOString();
        const to = moment(this.toDate).toISOString();
        query.push({
          createdAt: {
            between: [from, to],
          },
        });
      }

      if (this.service && this.service !== "All") {
        query.push({ service: { contains: this.service } });
      }

      if (!this.isAdminRole) {
        Auth.currentAuthenticatedUser().then((user) => {
          filter = {};
          query.push({ participants: { contains: user.attributes.email } });

          query.forEach((q) => {
            Object.assign(filter, q);
          });
        });
      } else {
        if (query.length > 0) {
          filter = {};
          query.forEach((q) => {
            Object.assign(filter, q);
          });
        }
      }

      const companySurvey = new CompanySurvey(filter);
      this.graphData = await companySurvey.getGraphData();

      this.graphDataTable = this.graphData.map(function (data) {
        // let participant = data.participants
        //   .substring(0, data.participants.lastIndexOf("@"))
        //   .replace(".", " ")
        //   .toLowerCase()
        //   .split(" ")
        //   .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        //   .join(" ");
        return {
          companyName: data.companyName,
          // participant: participant,
          event: data.event,
          impact: data.impact,
          performance: data.performance,
          valueformoney: data.valueformoney,
          feedback: data.feedback,
        };
      });

      this.supportChart();
      // this.participantsChart();
      this.impactChart();
      this.performanceChart();
      this.communicationChart();
      this.valueformoneyChart();
      this.loading = false;
    },
    async participantsChart() {
      const d = this.graphData.reduce((count, data) => {
        count[data.participants] = (count[data.participants] || 0) + 1;
        return count;
      }, {});

      var bigLabels = [];
      var index = 0;
      for (index = 0; index < Object.keys(d).length; index++) {
        bigLabels.push(
          Object.keys(d)
            [index].substring(0, Object.keys(d)[index].lastIndexOf("@"))
            .replace(".", " ")
            .toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
        );
      }

      this.dataCollection = {
        //Data to be represented on x-axis
        labels: bigLabels,
        datasets: [
          {
            label: "# of participants",
            data: Object.values(d),
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            borderColor: [
              "rgba(178, 215, 50, 1)",
              "rgba(102, 176, 50, 1)",
              "rgba(55, 95, 27, 1)",
              "rgba(230, 85, 13, 1)",
              "rgba(198, 40, 40, 1)",
              "rgba(227, 118, 194, 1)",
              "rgba(178, 215, 50, 1)",
              "rgba(102, 176, 50, 1)",
              "rgba(55, 95, 27, 1)",
              "rgba(230, 85, 13, 1)",
              "rgba(198, 40, 40, 1)",
              "rgba(227, 118, 194, 1)",
            ],
            borderWidth: 1,
          },
        ],
      };

      this.chartOptions = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      };

      this.participantsLoaded = true;
    },
    async supportChart() {
      let dd = {
        excellent: 0,
        verygood: 0,
        good: 0,
        average: 0,
        poor: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.event] = (count[data.event] || 0) + 1;
        return count;
      }, {});
      dd.excellent = d.excellent;
      dd.verygood = d.verygood;
      dd.good = d.good;
      dd.average = d.average;
      dd.poor = d.poor;
      this.supportLoaded = true;
      this.chartOptionsSupport = {
        legend: {
          display: false,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionSupport = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["excellent", "verygood", "good", "average", "poor"],
        datasets: [
          {
            label: "Data one",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)"
            ],
            data: [dd.excellent, dd.verygood, dd.good, dd.average, dd.poor]
          }
        ]
      };
    },
    async performanceChart() {
      let dd = {
        excellent: 0,
        verygood: 0,
        good: 0,
        average: 0,
        poor: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.performance] = (count[data.performance] || 0) + 1;
        return count;
      }, {});
      dd.excellent = d.excellent;
      dd.verygood = d.verygood;
      dd.good = d.good;
      dd.average = d.average;
      dd.poor = d.poor;
      this.performanceLoaded = true;
      this.chartOptionsPerformance = {
        legend: {
          display: false,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              // console.dir(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionPerformance = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["excellent", "verygood", "good", "average", "poor"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.excellent, dd.verygood, dd.good, dd.average, dd.poor],
          },
        ],
      };
    },
    async impactChart() {
      let dd = {
        excellent: 0,
        verygood: 0,
        good: 0,
        average: 0,
        poor: 0
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.impact] = (count[data.impact] || 0) + 1;
        return count;
      }, {});
      dd.excellent = d.excellent;
      dd.verygood = d.verygood;
      dd.good = d.good;
      dd.average = d.average;
      dd.poor = d.poor;
      this.impactLoaded = true;
      this.chartOptionsImpact = {
        legend: {
          display: false,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function(tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              // console.dir(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            }
          }
        }
      };
      this.dataCollectionImpact = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["excellent", "verygood", "good", "average", "poor"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.excellent, dd.verygood, dd.good, dd.average, dd.poor],
          },
        ],
      };
    },
    async communicationChart() {
      let dd = {
        excellent: 0,
        verygood: 0,
        good: 0,
        average: 0,
        poor: 0
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.communication] = (count[data.communication] || 0) + 1;
        return count;
      }, {});
      dd.excellent = d.excellent;
      dd.verygood = d.verygood;
      dd.good = d.good;
      dd.average = d.average;
      dd.poor = d.poor;
      this.communicationLoaded = true;
      this.chartOptionsCommunication = {
        legend: {
          display: false
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              // console.dir(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionCommunication = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["excellent", "verygood", "good", "average", "poor"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.excellent, dd.verygood, dd.good, dd.average, dd.poor],
          },
        ],
      };
    },
    async valueformoneyChart() {
      let dd = {
        excellent: 0,
        verygood: 0,
        good: 0,
        average: 0,
        poor: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.valueformoney] = (count[data.valueformoney] || 0) + 1;
        return count;
      }, {});
      dd.excellent = d.excellent;
      dd.verygood = d.verygood;
      dd.good = d.good;
      dd.average = d.average;
      dd.poor = d.poor;
      this.valueformoneyLoaded = true;
      this.chartOptionsValueformoney = {
        legend: {
          display: false,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              // console.dir(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionValueformoney = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["excellent", "verygood", "good", "average", "poor"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.excellent, dd.verygood, dd.good, dd.average, dd.poor],
          },
        ],
      };
    }
  },
  computed: {
    async isAdminRole() {
      const user = await Auth.currentAuthenticatedUser();
      const awsGroups =
        user.signInUserSession.accessToken.payload["cognito:groups"];
      if (awsGroups) {
        const roles =
          user.signInUserSession.accessToken.payload["cognito:groups"];
        return roles.includes("ADMIN");
      }
    },
  },
};
</script>
<style scoped>
.v-btn--open-dialog {
  top: 90px;
  position: fixed;
  margin: 0 0 16px 16px;
}
.navbar-link {
  text-decoration: none !important;
}
.v-toolbar {
  height: 20px !important;
}
</style>
